import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class ReceiptService {

constructor(
            private http: HttpClient, 
            private global: GlobalDataService
           ) { } 


    // getReceipt(page: number = 0) {
    //     let url = "";
    //     if(page){
    //       url = "?page="+page;
    //     }
    //     return this.http.get(this.global.httpUrl+"receipts"+url);
    // }

    getReceiptById(id: string) {
      return this.http.get(this.global.httpUrl+"receipts/"+id);
  }

   getReceiptByFilter(filter: any[],page:number = 0) {
         let url = "";
         if(page){
           url = "page="+page + "&";
         }
         if(filter){
           for (var item of filter) {
             url += item.name + "=" + item.value + "&";
          }
         }
         
         url = url.substring(0,url.length-1);
        
         return this.http.get(this.global.httpUrl + "receipts?" + url);
    }

    createInvoice(data: any){
        return this.http.post(this.global.httpUrl+"receipts", data);
    }

    printReceipt(id: any){
      return this.http.get(this.global.httpUrl+"receipts/print/"+id);
   }

    createReceipt(data: any){
        return this.http.post(this.global.httpUrl+"receipts", data);
    }

    deleteInvoice(id: any){
        return this.http.delete(this.global.httpUrl+"receipts/"+id);
    } 

}


// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/reseipts/receipt.service.ts